import React, { useEffect, useState } from 'react'
import VersantFormStep from './VersantFormStep'
import VersantClaimFormOverview from '../VersantClaimFormOverview'
import RpaClaimSubmitButton from '../../../../claimForm/submitClaim/RpaClaimSubmitButton'
import ClaimFormSync from '../../../../../../../../../components/authorised/order/edit/ClaimFormSync'
import { connect, useDispatch } from 'react-redux'
import ScrollToTarget from '../../../../../../../../../itrust_common/components/others/ScrollToTarget'
import DateFormatView from '../../../../../../../../../itrust_common/components/others/DateFormatView'
import { reduxForm } from 'redux-form'
import { visionInsuranceClaimFormEdit, visionInsuranceClaimFormUpdate } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'
import Alert from '../../../../../../../../../itrust_common/components/Alert'
import { DIRECT_SAVE_CLAIM_OPTIONS, isDirectSaveClaimOrg } from '../../../../claimForm/directSaveClaimOrgHelper'
import { withOrdersInsuranceId } from '../../../../../../../../../components/authorised/order/claimFormDropdownUtils'
import { SERVICE_FIELDS, getStep2Fields, validateVersantClaimForm, getInitialVersantValues, buildVersantClaimData } from '../versantClaimHelper'

function VersantClaimForm(props) {
  const { handleSubmit, editing, order, visionInsuranceClaimForm, visionInsuranceConfig, organisation } = props
  const { activeModule, formView } = editing
  const currentStep = activeModule || 'first'
  const dispatch = useDispatch()
  const isDirectSaveOrg = isDirectSaveClaimOrg(organisation?.subdomain, order?.store_id)
  const firstStepActionLabel = isDirectSaveOrg ? 'Save' : 'Next'
  const [selectedLocation, setSelectedLocation] = useState(
    visionInsuranceClaimForm?.location || DIRECT_SAVE_CLAIM_OPTIONS[0].value
  )

  useEffect(() => {
    if (visionInsuranceClaimForm?.location) {
      setSelectedLocation(visionInsuranceClaimForm.location)
    }
  }, [visionInsuranceClaimForm?.location])

  useEffect(() => {
    if (isDirectSaveOrg) {
      dispatch(visionInsuranceClaimFormEdit({ activeModule: 'first', formView: 'form' }))
    }
  }, [isDirectSaveOrg, visionInsuranceClaimForm?.id])

  const handleClaimFormUpdate = async (data) => {
    if (currentStep === 'first' || isDirectSaveOrg) {
      if (!data.eligibility?.data?.find((item) => item.active)) {
        Alert.warning('Please select a service to proceed.')
        return
      }

      await dispatch(visionInsuranceClaimFormUpdate({
        id: data.id,
        eligibility: data.eligibility,
        ...buildVersantClaimData(data),
        ...(isDirectSaveOrg ? { location: selectedLocation } : {}),
      }, withOrdersInsuranceId({ claim_sections: ['eligibility'] }, editing.orders_insurance_id)))

      const selectedServices = (data.eligibility?.data || []).filter((item) => item.active).map((item) => item.service_type)

      if (!isDirectSaveOrg && selectedServices.some((service) => SERVICE_FIELDS[service])) {
        dispatch(visionInsuranceClaimFormEdit({ activeModule: 'second', formView: 'form' }))
      }
      return
    }

    const fields = getStep2Fields(data.eligibility?.data)
    const hasSpectacleStep = fields.includes('spectacle_lens') && fields.some((field) => field !== 'spectacle_lens')
    const hasSpectacleOnly = fields.includes('spectacle_lens') && !hasSpectacleStep
    const serviceSections = buildVersantClaimData(data)
    const isLastStep = currentStep === 'final' ||
      ((currentStep === 'second' || currentStep === 'spectacle') && hasSpectacleOnly)

    await dispatch(visionInsuranceClaimFormUpdate({
      id: data.id,
      eligibility: data.eligibility,
      ...serviceSections,
      ...(isLastStep ? { ready_to_submit: true } : {}),
    }, withOrdersInsuranceId({}, editing.orders_insurance_id)))

    if (currentStep === 'second' && hasSpectacleStep) {
      dispatch(visionInsuranceClaimFormEdit({ activeModule: 'spectacle', formView: 'form' }))
      return
    }

    if (currentStep === 'second' || currentStep === 'spectacle') {
      if (hasSpectacleOnly) {
        dispatch(visionInsuranceClaimFormEdit({ activeModule: '', formView: 'overview' }))
      } else {
        dispatch(visionInsuranceClaimFormEdit({ activeModule: 'final', formView: 'form' }))
      }
      return
    }

    dispatch(visionInsuranceClaimFormEdit({ activeModule: '', formView: 'overview' }))
  }

  const handleSyncSuccessfully = () => {
    dispatch(visionInsuranceClaimFormEdit({ activeModule: 'first', formView: 'form' }))
  }

  const orderInsurance = order.orders_insurances_attributes?.find(
    (item) => item.id === editing?.orders_insurance_id,
  )
  const claimSubmissionAt = orderInsurance?.claim_submission_at || order.claim_submission_at

  return (
    <div className='px-6'>
      {order.insurance_payer_changed && (
        <h5 className='text-danger mb-5 text-center'>The insurance payer name is changed for the selected insurance.</h5>
      )}
      <div className='d-flex justify-content-between align-items-center'>
        <div>
          {visionInsuranceConfig?.visible && <RpaClaimSubmitButton order={order} />}
          {!isDirectSaveOrg && formView !== 'overview' && (
            <button
              type="button"
              className='btn btn-outline-primary'
              onClick={() => dispatch(visionInsuranceClaimFormEdit({ formView: 'overview' }))}
            >
              Overview
            </button>
          )}
          {claimSubmissionAt && (
            <span className='text-danger ml-6'>
              Previous Claim Send on <DateFormatView dateTime={claimSubmissionAt} />
            </span>
          )}
        </div>
        {isDirectSaveOrg ? (
          <div className="form-group mb-0 ml-md-5">
            <label className="mb-1" htmlFor="direct-save-claim-location">Location:</label>
            <select
              id="direct-save-claim-location"
              className="form-control"
              style={{ minWidth: '180px' }}
              value={selectedLocation}
              onChange={(e) => setSelectedLocation(e.target.value)}
            >
              {DIRECT_SAVE_CLAIM_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <ClaimFormSync label="Reset" handleAfterSyncSuccessfully={handleSyncSuccessfully} />
        )}
      </div>

      {!isDirectSaveOrg && formView === 'overview' ? (
        <VersantClaimFormOverview visionInsuranceClaimForm={visionInsuranceClaimForm} />
      ) : (
        <form onSubmit={handleSubmit(handleClaimFormUpdate)}>
          <VersantFormStep firstStepActionLabel={firstStepActionLabel} isDirectSaveOrg={isDirectSaveOrg} />
        </form>
      )}
    </div>
  )
}

VersantClaimForm = reduxForm({
  form: 'VersantClaimForm',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  shouldValidate: () => true,
  validate: validateVersantClaimForm,
  onSubmitFail: () => ScrollToTarget()
})(VersantClaimForm)

const mapStateToProps = (state) => {
  const { organisation: { organisation }, order: { order }, visionInsuranceClaimForm: { visionInsuranceClaimForm, saving, editing } } = state
  const { diagnosis_codes: _diagnosisCodes, procedure_codes: _procedureCodes, other_details: _otherDetails, ...claimForm } = visionInsuranceClaimForm || {}
  const initialVersantValues = getInitialVersantValues(visionInsuranceClaimForm)

  return {
    organisation,
    order,
    visionInsuranceClaimForm,
    editing,
    saving,
    visionInsuranceConfig: organisation.add_ons_config?.type?.vision_insurance,
    initialValues: {
      ...claimForm,
      ...initialVersantValues,
      services: {
        ...claimForm.services,
        ...initialVersantValues.services,
      },
      versant: {
        ...claimForm.versant,
        ...initialVersantValues.versant,
        final: {
          ...claimForm.versant?.final,
          ...initialVersantValues.versant.final,
          hcpcs_rows: (
            claimForm.versant?.final?.hcpcs_rows
            || initialVersantValues.versant.final?.hcpcs_rows
            || []
          ),
        },
      },
      spectacle_lens: {
        ...claimForm.spectacle_lens,
        ...initialVersantValues.spectacle_lens,
        perscriptions: {
          ...claimForm.spectacle_lens?.perscriptions,
          ...initialVersantValues.spectacle_lens.perscriptions,
        },
        len_information: {
          ...claimForm.spectacle_lens?.len_information,
          ...initialVersantValues.spectacle_lens.len_information,
          lens_design: {
            ...claimForm.spectacle_lens?.len_information?.lens_design,
            ...initialVersantValues.spectacle_lens.len_information.lens_design,
          },
        },
        frame: {
          ...claimForm.spectacle_lens?.frame,
          ...initialVersantValues.spectacle_lens.frame,
        },
      },
    },
  }
}

export default connect(mapStateToProps)(VersantClaimForm)
